export enum AddMembersFrom {
  'GROUP_INFO' = 'GROUP_INFO',
  'GROUP_CREATE_CARD' = 'GROUP_CREATE_CARD',
}

export type AddMembersFromType = keyof typeof AddMembersFrom;
